// Mirrors tailwind.config.ts theme.screens (Tailwind defaults — not overridden in config).
// resolveConfig cannot be used at runtime because tailwind.config.ts uses require() for plugins.
export const screens: Record<string, string> = {
    sm:  '640px',
    md:  '768px',
    lg:  '1024px',
    xl:  '1280px',
    '2xl': '1536px',
};
